import { render, staticRenderFns } from "./CreateFormRedPacket.vue?vue&type=template&id=6ee18a75"
import script from "./CreateFormRedPacket.vue?vue&type=script&lang=js"
export * from "./CreateFormRedPacket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports